<template>
  <div class="home home-shell">
    <Navigation />
    <v-main>
      <v-card fluid fill-height :loading="loading" class="home-card">
        <template v-if="this.$store.getters.getProfile.homeType === 'S3'">
          <SecurityDashboard/>
        </template>
        <v-layout v-if="this.$store.getters.getProfile.homeType === 'S2'">
            {{ this.$router.push({ path: '/degustations' }) }}
        </v-layout>
        <template v-if="this.$store.getters.getProfile.homeType === 'S1'">
          <!-- Toggle Buttons for CO2 & Electricité -->
          <!-- <div class="toggle-buttons">
              <v-btn :disabled="showCO2" @click="showCO2 = true" color="#3E6429">CO2</v-btn>
              <v-btn :disabled="!showCO2" @click="showCO2 = false" color="#9AAF8D">Electricité</v-btn>
          </div> -->
          <!-- <SecurityCO2/> -->
          <div class="gridy bg-white variables" v-if="$isMobile()">
            <UserAdminSitesT class="sites-panel sites-panel--full" @ready="userSitesReady" @selectSite="userSitesReady" />
          </div>
          <div class="gridy bg-white variables" v-else>
            <UserAdminSitesT class="sites-panel sites-panel--split" @ready="userSitesReady" @selectSite="userSitesReady" />
            <v-container v-if="site != null && visualization != null" class="viz-panel">
              <!-- <div class="d-flex flex justify-center align-items-center" style="gap: 8px; margin: 25px 0; width: 100%;">
                <v-btn @click.stop="query.interval = 'minute'; delayedReset += 1;">Les 5 dernières minutes (Temps réel)</v-btn>
                <v-btn @click.stop="query.interval = 'minute'; delayedReset += 1;">Les 5 dernières heures (Temps réel)</v-btn>
                <v-btn @click.stop="query.interval = 'minute'; delayedReset += 1;">Les 5 derniers jours</v-btn>
                <v-btn @click.stop="query.interval = 'minute'; delayedReset += 1;">Les 5 dernières semaines</v-btn>
                <v-btn @click.stop="query.interval = 'minute'; delayedReset += 1;">Les 5 derniers mois</v-btn>
              </div> -->
              <div class="group-graph">
                <h3 class="text-center back-button">Mes Graphiques</h3>
                <div class="text-black graph-items">
                  <button v-for="(item, index) in site.visualizations.filter(v => v.component !== 'RadarChart')" v-bind:key="index" @click.stop="applyVisualisationID(index)" class="btn btn-action btn-view"><!--<span class="material-symbols-outlined" style="margin: 0 5px;">arrow_forward_ios</span>-->{{ item.name }}</button>
                </div>
              </div>
              <div class="blur_bg">
                <h2 class="text-center text-black">{{ visualization.name }}</h2>
                <Visualization
                    :site="site"
                    :visualization="visualization"
                    :query="query"
                    :yearCompareQuery="null"
                    :reload="true"
                    :realtime="true"
                    intervalType="minutes"
                    :realtimeWindowSize="5"
                    :childIdsToName="childIdsToName"
                    v-bind:key="delayedReset"
                    textColor="white"
                ></Visualization>
              </div>
            </v-container>
            <v-container v-else class="viz-panel-empty"></v-container>
          </div>
        </template>
      </v-card>
    </v-main>
  </div>
</template>
<script>
import Navigation from "../components/Navigation.vue";
import UserAdminSites from "../components/UserAdminSites.vue";
import Map from "../components/Map.vue";
import Visualization from "@/components/Visualization";
import SecurityDashboard from "@/components/SecurityDashboard";
import {getSitePromise, getUserSite} from "@/vuex/modules/site";
import {EventBus} from "@/event-bus";
import {generateArrayOfYears} from "@/utils/dates";
import Vue from "vue";
import Degustation from "./Degustation.vue";
import snackbar from "../components/Snackbar";
import UserAdminSitesT from "../components/UserAdminSitesT.vue";

const YEARS = generateArrayOfYears();
const YEAR_COMPARE_QUERY_DEFAULT = {
  from: "2010-01-01",
  to: "2010-12-31",
  years: ["2010", "2011"],
  interval: "month",
};

Vue.use(require('vue-moment'));

const TIMERANGE_DEFAULT = [0, 48];
const QUERY_DEFAULT = {
  from: Vue.moment().subtract(4, 'days').format("YYYY-MM-DD"),
  to: Vue.moment().format("YYYY-MM-DD"),
  timerange: TIMERANGE_DEFAULT,
  interval: "day",
  yearCompareQuery: YEAR_COMPARE_QUERY_DEFAULT,
};

export default {
  components: {
    SecurityDashboard,
    Navigation,
    Visualization,
    UserAdminSitesT,
  },
  data() {
    return {
      profile: this.$store.state.profile.user,
      loading: true,
      site: null,
      query: QUERY_DEFAULT,
      visualization: null,
      childIdsToName: null,
      clientSites: null,
      delayedReset: 0,
      showCO2: true,
      styleIfTrue: {
        display: 'none'
      },
    };
  },
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.sm
    }
  },
  mounted() {
    this.$nextTick(function () {
      //return nothing
    });
  },
  methods: {
    async userSitesReady(siteID) {
      EventBus.$on('applySiteID', this.applySiteID);
      await this.applySiteID(siteID);
      this.loading = false;
    },
    applyVisualisationID(vizID){
        this.visualization = this.site.visualizations[vizID];
        this.delayedReset += 1;
    },
    async getChildIdsToName() {
      let childIdsToName = {};
      if (this.site.relations && this.site.relations.children)
        for (let child of this.site.relations.children) {
          let childSite = await this.getChildSite(child.id);
          childIdsToName[child.id] = childSite.name;
        }
      return childIdsToName;
    },
    async getChildSite(child_id) {
      let childSite;
      let filteredSites = this.clientSites.filter((s) => s.id == child_id);
      if (filteredSites.length == 1) {
        childSite = filteredSites[0];
      } else if (
          filteredSites == 0 &&
          this.$store.state.profile.user.role == "admin"
      ) {
        childSite = await getSitePromise(this.$store, child_id);
      } else {
        console.log("Error : filter give ", filteredSites);
      }
      return childSite;
    },
    fetchClientSites(client_id, callback) {
      this.updateUser(() => {
        this.clientSites = this.getClientSites();
        this.ready = true;
        if (callback) {
          callback();
        }
      });
    },
    getClientSites(client_id) {
      return this.$store.state.profile.user.sites.filter((site) => {
        return site.client_id == client_id;
      });
    },
    async applySiteID (siteID) {
      if (this.$isMobile() === false) {
        this.site = getUserSite(this.profile, siteID);
        this.visualization = this.site.visualizations[0];
        //this.query = user.visualization[this.site.id];
        this.childIdsToName = await this.getChildIdsToName();
        this.delayedReset += 1;
      }
    },
  },
};

</script>

<style scoped>
  .home-shell {
    height: 100vh;
    overflow: hidden;
  }

  .home-card {
    height: calc(100vh - 85px - 64px);
  }

  .sites-panel--full {
    width: 100%;
    height: calc(100vh - 85px - 64px);
    min-height: 0;
  }

  .sites-panel--split {
    width: 35%;
    height: calc(100vh - 85px - 64px);
    min-height: 0;
  }

  .viz-panel {
    width: 65%;
    position: sticky;
    top: 0;
    margin: auto 25px;
  }

  .viz-panel-empty {
    width: 80%;
  }

  .gridy {
      display: flex;
      justify-content: center;
      min-width: 100%;
      position: relative;
      height: 100%;        /* Keep this */
      min-height: 0;       /* ADD THIS - crucial for flex children to shrink/scroll */
  }

  /* ============================================
     Responsive (mobile & tablet only) — the fixed
     100vh math above assumes a single-line desktop
     toolbar/footer. On small screens the footer wraps
     to several lines, so trade the fixed subtraction
     for natural, scrollable flow instead of clipping.
     ============================================ */
  @media (max-width: 960px) {
    .home-shell {
      height: auto;
      min-height: 100vh;
      min-height: 100dvh;
      overflow: visible;
    }

    .home-card {
      height: auto;
      min-height: calc(100vh - 85px);
      min-height: calc(100dvh - 85px);
      overflow: visible;
    }

    .gridy {
      flex-direction: column;
      height: auto;
    }

    .sites-panel--full,
    .sites-panel--split {
      width: 100%;
      height: auto;
      min-height: 60vh;
    }

    .viz-panel,
    .viz-panel-empty {
      width: 100%;
      position: static;
      margin: 16px 0 0;
    }
  }

  .dflex {
      display: flex;
      justify-content: center;
      align-items: center;
  }

  .bg_main {
      background-image: linear-gradient(to bottom right, #3E6429, #404040);
  }

  .blur_bg {
      border-color: rgb(246 135 179 / 0.1);
      background-color: #9AAF8D33;
      border-width: 1px;
      border-radius: 0.75rem;
      box-shadow: 0 0 #0000, 0 0 #0000, 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
      backdrop-filter: blur(4px);
  }

  .material-symbols-outlined {
      font-family: 'Material Symbols Outlined', sans-serif;
      font-variation-settings: 'FILL' 0, 'wght' 500, 'GRAD' 0, 'opsz' 48;
      font-size: 1.5rem;
  }

  .text-black {
    color: black;
  }

  .variables {
    /* Primary greens - refined palette */
    --color-primary: #2d5a3d;
    --color-primary-light: #3d7a52;
    --color-primary-lighter: #5a9e6f;
    --color-primary-dark: #1e3d29;
    --color-primary-bg: #e8f0eb;

    /* Accent */
    --color-accent: #5a9e6f;
    --color-accent-light: #a8d4b8;

    /* Surfaces - clean whites and light grays */
    --color-surface: #ffffff;
    --color-surface-secondary: #fafbfa;
    --color-surface-hover: #f0f4f1;
    --color-background: #f5f7f6;

    /* Borders */
    --color-border: #e2e8e4;
    --color-border-light: #f0f4f1;

    /* Text */
    --color-text-primary: #1a2e1f;
    --color-text-secondary: #5a6b5e;
    --color-text-muted: #8a998e;

    /* Status colors */
    --color-danger: #dc2626;
    --color-danger-bg: #fef2f2;
    --color-warning: #d97706;
    --color-warning-bg: #fffbeb;
    --color-success: #059669;
    --color-success-bg: #ecfdf5;

    /* Shadows */
    --shadow-xs: 0 1px 2px rgba(45, 90, 61, 0.04);
    --shadow-sm: 0 1px 2px rgba(45, 90, 61, 0.05);
    --shadow-md: 0 4px 12px rgba(45, 90, 61, 0.08);
    --shadow-lg: 0 12px 40px rgba(45, 90, 61, 0.12);

    /* Radii */
    --radius-sm: 6px;
    --radius-md: 10px;
    --radius-lg: 16px;
    --radius-xl: 20px;

    /* Transitions */
    --transition-fast: 150ms ease;
    --transition-normal: 200ms cubic-bezier(0.4, 0, 0.2, 1);
    --transition-smooth: 300ms cubic-bezier(0.4, 0, 0.2, 1);

    /* Graph/Visualization specific */
    --color-graph-bg: #ffffff;

    font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  }

  .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 10px 18px;
    border: none;
    border-radius: var(--radius-md);
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all var(--transition-fast);
    white-space: nowrap;
  }

  .btn-action {
    padding: 8px 12px;
    background: var(--color-surface);
    border: 1px solid var(--color-border);
    font-size: 13px;
  }

  .btn-action:hover {
    background: var(--color-primary-bg);
    border-color: var(--color-primary-lighter);
    color: var(--color-primary);
  }

  .btn-view {
    background: var(--color-primary-bg);
    border-color: var(--color-primary-lighter);
    color: var(--color-primary);
  }

  .btn-view:hover {
    background: var(--color-primary);
    border-color: var(--color-primary);
    color: white;
  }

  .site-name {
    font-weight: 500;
    color: var(--color-text-primary);
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .graph-items {
    width: 100%;
    margin: 10px 0;
    display: flex;
    flex-direction: row;
    gap: 8px;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    /*border: 1px solid var(--color-border);
    border-radius: 15px;
    padding: 10px 0;*/
  }

  .back-button {
    padding: 14px 20px;
    background: var(--color-surface-secondary);
    border: none;
    border-bottom: 1px solid var(--color-border-light);
    /*font-size: 14px;*/
    font-weight: 500;
    color: var(--color-text-secondary);
    cursor: pointer;
    width: 100%;
    transition: all var(--transition-fast);
  }

  .group-graph {
    border: 1px solid var(--color-border);
    border-radius: 15px;
    margin-bottom: 10px;
  }

</style>
